export interface MenuItemProps {
  text: string;
  link: string;
}

export const MenuItem = ({ text, link }: MenuItemProps) => {
  return (
    <div role="none">
      <a
        className={`menu-item text-dark-200 p-0 text-[22px] font-bold lg:px-2 lg:pt-2 lg:text-base lg:font-medium xl:px-4`}
        href={link}
      >
        {text}
      </a>
    </div>
  );
};
